/**
 * Safely formats a price value for display
 * @param {any} value - The price value to format
 * @param {number} decimals - Number of decimal places
 * @returns {string} - Formatted price string
 */
export const formatPrice = (value, decimals = 2) => {
  // First convert to number or default to 0
  const numberValue = value === undefined || value === null ? 0 : Number(value);
  
  // Check if conversion resulted in a valid number
  if (isNaN(numberValue)) {
    console.warn(`Invalid price value: ${value}`);
    return "0.00";
  }
  
  // Format to specified decimal places
  return numberValue.toFixed(decimals);
};

/**
 * Calculates discounted price based on original price and discount details
 * @param {number} originalPrice - Original price before discount
 * @param {number} quantity - Quantity of items
 * @param {string} discountType - Type of discount (percentage, amount, none)
 * @param {number} discountValue - Value of discount
 * @returns {object} Object with unitPrice and totalPrice
 */
export const calculateDiscountedPrice = (originalPrice, quantity, discountType, discountValue) => {
  // Convert inputs to numbers with safe fallbacks
  const price = Number(originalPrice) || 0;
  const qty = Number(quantity) || 1;
  const discount = Number(discountValue) || 0;

  // Calculate unit price based on discount type
  let finalUnitPrice = price;
  if (discountType === 'percentage' && discount) {
    finalUnitPrice = price * (1 - discount / 100);
  } else if (discountType === 'amount' && discount) {
    finalUnitPrice = Math.max(0, price - discount);
  }

  return {
    unitPrice: finalUnitPrice,
    totalPrice: finalUnitPrice * qty
  };
};
